import React, { useState, useRef, useMemo, Fragment, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import './Sidebar.scss';

Element.prototype.parents = function (selector) {
    let elements = [];
    let elem = this;
    let ishaveselector = selector !== undefined;

    while ((elem = elem.parentElement) !== null) {
        if (elem.nodeType !== Node.ELEMENT_NODE) {
            continue;
        }

        if (!ishaveselector || elem.matches(selector)) {
            elements.push(elem);
        }
    }
    return elements;
};

export default function Sidebar({ sidebarVisible, user, toogleSidebar }) {
    user = user ? user : {};

    const sidebarRef = useRef();
    const [state, setState] = useState(null);
    const [opened, setOpened] = useState(false);

    useEffect(() => {
        setOpened(sidebarVisible);
    }, [sidebarVisible]);

    useEffect(() => {
        document.addEventListener('click', (ev) => {
            setState({
                focusOut: ev.target.parents('#sidebar').length === 0,
                toggleButton:
                    ev.target.parents('#toggle-sidebar').length > 0 ||
                    ev.target.id === 'toggle-sidebar',
            });
        });
    }, []);

    useEffect(() => {
        if (state !== null) {
            if (!state.toggleButton) {
                if (state.focusOut && opened) {
                    toogleSidebar(false);
                }
            }
        }
    }, [opened, state, toogleSidebar]);

    const menu = useMemo(
        () => [
            { text: 'Início', icon: 'home', path: '/', topFixed: true, divider: true },
           /*  {
                text: 'Combustível',
                icon: 'tint',
                children: [
                    {
                        text: 'Aferição',
                        children: [
                            {
                                text: 'Inserir aferição',
                                path: '/combustivel/afericao/inserir',
                            },
                            { text: 'Análise', path: '/combustivel/afericao/analise' },
                        ],
                    },
                    { text: 'Drenagem', path: '/combustivel/drenagem' },
                ],
            }, */
            {
                text: 'Controladoria',
                icon: 'calculator',
                children: [
                    {
                        text: 'Apuração Fechamento de Caixa',
                        path: '/controladoria/apuracao-fechamento-caixa',
                    },
                ],
            },
            {
                text: 'Recebíveis',
                icon: 'credit card',
                children: [
                    {
                        text: 'Cartão',
                        children: [
                            { text: 'Upload NF', path: '/recebiveis/cartao/upload-nf' },
                            { text: 'Coleta de Dados', path: '/recebiveis/cartao/coleta-de-dados' },
                        ],
                    },
                    {
                        text: 'Cupons de Venda',
                        icon: 'file alternate outline',
                        path: '/recebiveis/cupons',
                    },
                    {
                        text: 'Compliance Fiscal',
                        icon: 'file alternate outline',
                        path: '/recebiveis/compliance-fiscal',
                    },
                ],
            },
            {
                text: 'Fiscal / Contábil',
                icon: 'line graph',
                children: [
                    { text: 'Sped', path: '/fiscal-contabil/sped' },
                    {
                        text: 'Conferências',
                        children: [
                            {
                                text: 'NFC-e',
                                path: '/fiscal-contabil/conferencias/nfce/consultar-sefaz',
                            },
                        ],
                    },
                    {
                        text: 'DRE',
                        children: [
                            {
                                text: 'Perdas Devedores Duvidosos',
                                path: '/fiscal-contabil/dre/perdas-devedores-duvidosos',
                            },
                            { text: 'Apuração ICMS', path: '/fiscal-contabil/dre/apuracao-icms' },
                        ],
                    },
                    { text: 'Empresas', path: '/fiscal-contabil/empresas' },
                    { text: 'Regulamento ICMS', path: '/fiscal-contabil/regulamento-icms' },
                ],
            },
            {
                text: 'Dep. Pessoal',
                icon: 'group',
                children: [
                    // { text: 'Início', path: '/departamento-pessoal' },
                    {
                        text: 'Rastreio de Atividades',
                        path: '/departamento-pessoal/rastreio-de-atividades',
                    },
                ],
            },
            // { text: 'Cobrança', icon: 'dollar', children: [
            //     { text: 'Teste de mala direta', path: '/cobranca/teste-mala-direta' }
            // ]},
            // { text: 'Status', icon: 'area graph', children: [
            //     {
            //         text: 'Sincronia Base de Integração',
            //         icon: <Icon.Group size='huge'>
            //                 <Icon name='puzzle' />
            //                 <Icon corner='bottom right' name='add' />
            //               </Icon.Group>,
            //         path: '/status/sincronia-base-de-integracao',
            //     },
            // ]},
            {
                text: 'Valid Fisco',
                icon: 'file alternate outline',
                children: [
                    // { text: 'Análise de documentos', path: '/valid-fisco/analise-de-documentos' },
                    { text: 'Importar XML (NFs)', path: '/valid-fisco/importar-xmls' },
                    // { text: 'Dashboard', path: '/valid-fisco/dashboard' },
                ],
            },
            {
                text: 'Control Docs',
                icon: 'print',
                children: [
                    { text: 'Conferência de cupons', path: '/control-docs/conferencia-de-cupons' },
                ],
            },
            {
                text: 'Financeiro',
                icon: 'money bill alternate outline',
                children: [
                    {
                        text: 'Correções',
                        children: [
                            {
                                text: 'Alteração de Centro de Custo',
                                path: '/financeiro/correcoes/alteracao-centro-de-custo',
                            },
                        ],
                    },
                ],
            },
        ],
        [],
    );

    function toggleSubMenu(ev) {
        const target = ev.target.closest('.item');
        if (target.querySelector('i.dropdown')) {
            target.classList.toggle('active');
        }

        const sub = target.nextElementSibling;

        if (sub.classList.contains('submenu')) {
            if (sub.classList.contains('d-block')) {
                sub.classList.remove('d-block');
            } else {
                const openedSubMenus = sidebarRef.current.querySelectorAll(
                    'li > ul.submenu.d-block',
                );
                if (openedSubMenus) {
                    for (let i = 0; i < openedSubMenus.length; ++i) {
                        if (openedSubMenus[i] !== sub.parents('.submenu')[0]) {
                            openedSubMenus[i].classList.remove('d-block');
                            openedSubMenus[i].parentNode
                                .querySelector('.item')
                                .classList.toggle('active');
                        }
                    }
                }
                sub.classList.add('d-block');
            }
        }
    }

    return (
        <div id="sidebar" ref={sidebarRef} className={opened ? 'opened' : null}>
            <ul id="menu">
                {menu
                    .filter((m) => m.topFixed)
                    .concat(
                        menu
                            .filter((m) => !m.topFixed)
                            .sort((a, b) => (a.text < b.text ? -1 : a.text > b.text ? 1 : 0)),
                    )
                    .map((m, i) => (
                        <Fragment key={i}>
                            {(!('show' in m) || ('show' in m && m.show)) && (
                                <li key={i}>
                                    <div
                                        className="item"
                                        onClick={m.children ? toggleSubMenu : null}
                                    >
                                        {!m.children ? (
                                            <Link to={m.path}>{m.text}</Link>
                                        ) : (
                                            <span>{m.text}</span>
                                        )}
                                        <div className="icons">
                                            {m.children && (
                                                <i aria-hidden="true" className="dropdown icon"></i>
                                            )}
                                            {m.icon && <Icon name={m.icon} />}
                                        </div>
                                    </div>
                                    {m.children && (
                                        <ul className="submenu">
                                            {m.children.map((c1, i2) => (
                                                <Fragment key={i2}>
                                                    {(!('show' in c1) ||
                                                        ('show' in c1 && c1.show)) && (
                                                        <li key={i2}>
                                                            <div
                                                                className="item"
                                                                onClick={
                                                                    c1.children
                                                                        ? toggleSubMenu
                                                                        : null
                                                                }
                                                            >
                                                                {!c1.children ? (
                                                                    <Link to={c1.path}>
                                                                        {c1.text}
                                                                    </Link>
                                                                ) : (
                                                                    <span>{c1.text}</span>
                                                                )}
                                                                {c1.children && (
                                                                    <i
                                                                        aria-hidden="true"
                                                                        className="dropdown icon"
                                                                    ></i>
                                                                )}
                                                            </div>
                                                            {c1.children && (
                                                                <ul className="submenu">
                                                                    {c1.children.map((c2, i3) => (
                                                                        <Fragment key={i3}>
                                                                            {(!('show' in c2) ||
                                                                                ('show' in c2 &&
                                                                                    c2.show)) && (
                                                                                <li key={i3}>
                                                                                    <div className="item">
                                                                                        <Link
                                                                                            to={
                                                                                                c2.path
                                                                                            }
                                                                                        >
                                                                                            »{' '}
                                                                                            {
                                                                                                c2.text
                                                                                            }
                                                                                        </Link>
                                                                                    </div>
                                                                                </li>
                                                                            )}
                                                                        </Fragment>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </li>
                                                    )}
                                                </Fragment>
                                            ))}
                                        </ul>
                                    )}
                                    {m.divider && <span className="divider"></span>}
                                </li>
                            )}
                        </Fragment>
                    ))}
            </ul>
        </div>
    );
}
